import { selectShouldRecenterCamera } from "@/store/modes/export-mode-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { CameraViewType, SetCameraView } from "@/utils/cam-view";
import { DEFAULT_PERSPECTIVE_FOV } from "@faro-lotv/lotv";
import { Camera } from "@react-three/fiber";
import { useEffect, useState } from "react";
import { Matrix4, Quaternion, Vector3 } from "three";

/**
 *
 * @param setCameraView Function to set an animation to a given camera view, if needed
 * @param camera The camera to be animated
 * @param targetCameraPos Target position to animate the camera to
 * @param pointCloudCenterTarget Target point the camera should look at
 */
export function useFrameCameraIfNeeded(
  setCameraView: SetCameraView,
  camera: Camera,
  targetCameraPos: Vector3,
  pointCloudCenterTarget: Vector3,
): void {
  const shouldRecenterCamera = useAppSelector(selectShouldRecenterCamera);

  const [cameraRecentered, setCameraRecentered] =
    useState(!shouldRecenterCamera);

  // This useEffect is run only once if 'shouldRecenterCamera' is true
  useEffect(() => {
    if (!cameraRecentered) {
      const mat = new Matrix4().lookAt(
        camera.position,
        pointCloudCenterTarget,
        camera.up,
      );
      const quaternion = new Quaternion();
      mat.decompose(new Vector3(), quaternion, new Vector3());
      setCameraView({
        position: targetCameraPos,
        rotation: quaternion,
        zoomLevel: DEFAULT_PERSPECTIVE_FOV,
        type: CameraViewType.perspective,
        target: pointCloudCenterTarget,
      });
      setCameraRecentered(true);
    }
  }, [
    cameraRecentered,
    setCameraView,
    camera,
    targetCameraPos,
    pointCloudCenterTarget,
  ]);
}
